import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const inova: GetCustomerCopyFunc = () => {
  return {
    workLifeServicesCustomDescription: 'Financial advice, legal services, family support, and more.',
  }
}
